/* eslint-disable */
const mutations = {
  beginRequest(state, channel) {
    if (state.channel !== channel) {
      state.data = [];
      state.isLoaded = false;
    }
    state.channel = channel;
    state.requestId += 1;
    state.isLoading = true;
  },
  updateIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },

  setData(state, payload) {
    state.isLoaded = true;
    state.data = payload;
  },
};

export default mutations;
